import React from "react";
import { useNavigate } from "react-router-dom";

const DeliveryProfile = () => {
  const navigate = useNavigate();

  // get user from sessionStorage
  const user = JSON.parse(sessionStorage.getItem("active-delivery"));

  if (!user) {
    return (
      <div className="container mt-5">
        <div className="alert alert-warning text-center">
          Please login to view your profile.
        </div>
      </div>
    );
  }

  const handleLogout = () => {
    sessionStorage.removeItem("active-user");
    navigate("/"); // redirect to home or login
  };

  return (
    <div className="auth-background">
      <div className="container mt-4">
        <div className="card shadow-lg">
          <div className="card-header bg-color custom-bg-text text-center">
            <h2>User Profile</h2>
          </div>
          <div className="card-body text-color">
            <div className="row mb-3">
              <div className="col-md-6">
                <p>
                  <b>First Name:</b> {user.firstName}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <b>Last Name:</b> {user.lastName}
                </p>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <p>
                  <b>Email:</b> {user.emailId}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <b>Phone:</b> {user.phoneNo}
                </p>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <p>
                  <b>Role:</b> {user.role}
                </p>
              </div>
            </div>

            {user.address && (
              <div className="row mb-3">
                <div className="col-md-12">
                  <p>
                    <b>Address:</b>
                    <br />
                    {user.address.street}, {user.address.city} -{" "}
                    {user.address.pincode}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryProfile;
